const METRIKA_COUNTER_ID = 102936123;

export function trackModalOpen(source) {
    if (typeof window.ym !== 'function') {
        return;
    }

    const searchParams = new URLSearchParams(window.location.search);

    let formSource = source;

    if (!formSource && searchParams.get('open_form') === 'true') {
        formSource = 'article';
    }

    if (!formSource) {
        formSource = 'site';
    }

    const leadType = formSource === 'app_beta'
        ? 'app_instruction'
        : 'site_client';

    window.ym(METRIKA_COUNTER_ID, 'reachGoal', 'form_open', {
        form: {
            source: formSource,
            lead_type: leadType
        }
    });

    if (formSource === 'app_beta') {
        window.ym(
            METRIKA_COUNTER_ID,
            'reachGoal',
            'app_beta_form_open'
        );
    }
}